module.exports = __webpack_public_path__ + "static/media/Screen Shot 2020-09-07 at 3.25.55 PM.633b223d.png";